import React from "react";
import styled from "styled-components";

export const Heading = ({ heading = false }) => {
  return (
    heading && (
      <HeadingWrapper id="heading">
        <HeadingContainer>
          <HeadingContent>{heading}</HeadingContent>
        </HeadingContainer>
      </HeadingWrapper>
    )
  );
};

// ======== HEADING ======== //

const HeadingWrapper = styled.div`
  background: #102b4e;
`;

const HeadingContainer = styled.div`
  padding: 30px 15px 20px 15px;
`;

const HeadingContent = styled.h3`
  color: #ffffff;
  font-size: 32px;
  font-weight: 700;
  position: relative;
  text-align: center;
  text-transform: uppercase;
  margin: 0;

  @media only screen and ${(props) => props.theme.maxMedia.large} {
    font-size: 50px;
  }
`;
